import Container from "components/shared/Container";

const MessagesContentContainer = ({ children }) => (
	<div className={`syndicated-message-center__content`}>
		<Container>{children}</Container>
	</div>
);

export default MessagesContentContainer;
